import api from "./api";
import endpoints from "./endpoints";

export default {
  get(languages) {
    return api
      .get(endpoints.attributeManager.catalogGroupAttributes.get, {
        params: { languages }
      })
      .then((x) => Promise.resolve(x.data));
  },
  update(model) {
    return api.post(endpoints.attributeManager.catalogGroupAttributes.update, model).then((x) => Promise.resolve(x.data));
  },
  delete(items) {
    return api.post(endpoints.attributeManager.catalogGroupAttributes.delete, items).then((x) => Promise.resolve(x.data));
  },
  savedeepLTranslated: async function (model, sourceLanguage) {
    return api
      .post(endpoints.attributeManager.catalogGroupAttributes.deepL, model, { params: { sourceLanguage: sourceLanguage } })
      .then((x) => Promise.resolve(x.data));
  }
};
